import { render, staticRenderFns } from "./DicaSaude.vue?vue&type=template&id=91fd093e&scoped=true&"
import script from "./DicaSaude.vue?vue&type=script&lang=js&"
export * from "./DicaSaude.vue?vue&type=script&lang=js&"
import style0 from "./DicaSaude.vue?vue&type=style&index=0&id=91fd093e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fd093e",
  null
  
)

export default component.exports